/**
 * BrandLogo — TradeFlow UK
 *
 * Pass `size` to pick a preset (sm | md | lg). Defaults to md.
 */
const SIZES = {
  sm: "w-8 h-8",   // footer
  md: "w-9 h-9",   // navbar
  lg: "w-10 h-10", // auth pages
};

// Bump this when the logo file is replaced to force browser cache invalidation.
const LOGO_VERSION = "2";

export default function BrandLogo({ size = "md", className = "" }) {
  return (
    <img
      src={`/logo.jpg?v=${LOGO_VERSION}`}
      alt="TradeFlow UK"
      data-testid="brand-logo"
      className={`${SIZES[size] || SIZES.md} object-contain rounded-md shrink-0 ${className}`}
      draggable={false}
    />
  );
}
